import PropTypes from 'prop-types';
import styled from 'styled-components';
import React from 'react';
import Link from 'next/link';
import { withRouter } from 'next/router';
import { getNewLinkParams } from './GetNewLinkParams';


const Control = styled.div`
  & > a {
    color: #1e2022;
    cursor: pointer;
  }
  & > label, & > div, & > a {
    cursor: pointer;
    user-select: none;
  }
`;

// NOTE: checkbox inside `<a>` is a decoration
// maybe replace with `<div>` later
class SearchFilterCheckboxView extends React.Component {
  isCheckboxChecked = value => {
    const { filter, name } = this.props;

    if (this.type() === 'object') {
      return filter[name].includes(value);
    }

    return filter[name];
  };

  type = () => {
    const { name, defaultFilter } = this.props;
    return typeof defaultFilter[name];
  };

  // noinspection JSDeprecatedSymbols
  id = () => `${this.constructor.name}-${this.props.label}`;

  getNewLinkParams = (checked) => getNewLinkParams(
    this.props.router,
    (query, params) => {
      const { value, name } = this.props;
      let list = query[name] || [];

      if (checked) {
        list = list.filter((sid) => sid !== value);
      } else {
        list = [...list, value];
      }
      if (list.length) {
        params.set(name, list.join(' '));
      } else {
        params.delete(name);
      }
    },
  );

  stop = (e) => e.stopPropagation()

  render() {
    const { value, label } = this.props;

    const checked = this.isCheckboxChecked(value);

    const linkParams = this.getNewLinkParams(checked, value);

    const id = this.id();

    // noinspection HtmlUnknownTarget
    return (
      <div className="form-group">
        <Control className="custom-control custom-checkbox">
          <Link
            scroll={false}
            href={linkParams.href}
            as={linkParams.as}
          >
            <a onClick={this.stop}>
              <input
                tabIndex={-1} // because checkbox is a decoration
                type="checkbox"
                className="custom-control-input"
                id={id}
                value={value}
                onChange={() => {}} // sic
                checked={checked}
              />
              <label
                tabIndex={-1} // because checkbox is a decoration
                className="custom-control-label"
                htmlFor={id}
              >
                {label}
              </label>
            </a>
          </Link>
        </Control>
      </div>
    );
  }
}

const SearchFilterCheckbox = withRouter(SearchFilterCheckboxView);

SearchFilterCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  name: PropTypes.string.isRequired,
  filter: PropTypes.shape({}).isRequired,
  defaultFilter: PropTypes.shape({}).isRequired,
};

SearchFilterCheckboxView.propTypes = {
  ...SearchFilterCheckbox.propTypes,
  router: PropTypes.shape({
    asPath: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default SearchFilterCheckbox;
